import { Button, ButtonGroup, Menu, MenuItem, MenuList } from "@mui/material"
import React from "react";
import { useRef, useState } from "react";
import Icon from "src/@core/components/icon";
import { EntityWithIdAndDescription, EntityWithIdAndDescriptionFields } from "src/types/baseEntities";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const ICON_SEND = <Icon icon="material-symbols:send" />


type SplitButtonProps<TOption extends EntityWithIdAndDescription> = {
    options: Array<TOption> /* | Promise<Array<TOption>> */ // TODO: seguir con esto, así carga las opciones async
    onClick: ((selected: TOption) => void) | ((selected: TOption) => Promise<void>)
}

// TODO: agregar que extienda las button props para que sea editable


const SplitButton = <TOption extends EntityWithIdAndDescription>(props: SplitButtonProps<TOption>) => {

    const { options, onClick } = props;

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = React.useState<TOption>(options[0]);

    const anchorRef = useRef<HTMLDivElement>(null);

    const handleClick = () => {
        onClick(selected)
    }

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        selection: TOption,
    ) => {
        setSelected(selection);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };


    const handleClose = (event: Event) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) return

        setOpen(false);
    };

    return (
        <React.Fragment>
            <ButtonGroup variant='contained' ref={anchorRef}>
                <Button
                    onClick={handleClick}
                    endIcon={ICON_SEND}
                    sx={{
                        whiteSpace: 'nowrap'
                    }}
                >
                    {selected[EntityWithIdAndDescriptionFields.Description]}
                </Button>
                <Button
                    size="small"
                    onClick={handleToggle}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Menu
                open={open}
                anchorEl={anchorRef.current}
                onClose={handleClose}
            >
                <MenuList>
                    {
                        options.map((option) => (
                            <MenuItem
                                key={option[EntityWithIdAndDescriptionFields.Id]}
                                value={option[EntityWithIdAndDescriptionFields.Id]}
                                selected={option[EntityWithIdAndDescriptionFields.Id] === selected[EntityWithIdAndDescriptionFields.Id]}
                                onClick={(event) => handleMenuItemClick(event, option)}
                            >
                                {option[EntityWithIdAndDescriptionFields.Description]}
                            </MenuItem>
                        ))
                    }
                </MenuList>
            </Menu>
        </React.Fragment >
    )
}


export default SplitButton;
